import moment from 'moment';
import React, { FC } from 'react';
import { ProjectId } from 'api/models';
import { useTasksFromStore } from 'data/tasks/hooks';
import { EmptyContent } from './_card-empty';
import { DataContent } from './_card-list';

export const Content: FC<{ projectId: number }> = ({ projectId }) => {
  const tasks = useTasksFromStore(ProjectId(projectId));

  const data = tasks
    .filter((task) => {
      return (
        task.completedAt &&
        task.dueDate &&
        moment(task.completedAt)
          .endOf('day')
          .isAfter(moment(task.dueDate).endOf('day'))
      );
    })
    .sort(
      (a, b) =>
        moment(b.completedAt).diff(moment(b.dueDate), 'days') -
        moment(a.completedAt).diff(moment(a.dueDate), 'days'),
    );

  return (
    <>{data.length > 0 ? <DataContent data={data} /> : <EmptyContent />}</>
  );
};
